<template>
  <v-row>  
    <v-col lg="12" class="page-title">      
      <v-card class="mx-auto mb-1" flat>
        <v-card-title>         
          <v-text-field
            hide-details
            :value="search"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="grey-lighten-3 ma-2"
            background-color="#FAFAFA"
            outlined
            fieldset="#ddd"            
            @input="changeData($event)"
            dense
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn  depressed class="white--text" :color="btnColor" :title="btnName" :to="btnRoute"
             v-if="btnEnable && hasPermission(btnPermission)">
              {{ btnName }}
          </v-btn>
        </v-card-title>
      </v-card>
      <v-progress-linear v-if="loading" indeterminate color="blue darken-2"></v-progress-linear>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "PageTitleWithSearch",
  props: ["title", "loading", "data", "search", "btnName", "btnColor", "btnRoute", "btnPermission", "btnEnable"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },

  methods: {
    changeData(event) {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        this.$emit("searchText", event);
      }, 500);
    }
  }
};
</script>
<style>
.page-title .v-card__title {
  padding: 0;
  padding-left: 15px;
  padding-right: 15px;
}


</style>
